document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('product-gallery');
  if (!gallery) return;

  const allMedia = gallery.querySelectorAll('[data-media-id]');

  function filterByVariant(variant) {
    if (!variant?.media) return;

    const variantMediaIds = variant.media.map(m => String(m.id));

    allMedia.forEach(el => {
      if (variantMediaIds.includes(String(el.dataset.mediaId))) {
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });

    // Scroll to first visible
    const first = gallery.querySelector(`[data-media-id="${variantMediaIds[0]}"]`);
    if (first) first.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  }

  document.querySelectorAll('variant-picker').forEach(picker => {
    picker.addEventListener('variant:changed', (event) => {
      filterByVariant(event.detail?.variant);
    });
  });
});

